"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRecognitionFormModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = __importDefault(require("react"));
const CustomerRecognitionForm_1 = require("./CustomerRecognitionForm.js");
const Component = (_a) => {
    var { container, onClose, open, enableCloseButton = true } = _a, props = __rest(_a, ["container", "onClose", "open", "enableCloseButton"]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Modal, Object.assign({ open: open }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.ModalContent, Object.assign({ css: { width: '100%' }, container: container }, { children: [enableCloseButton && (0, jsx_runtime_1.jsx)(flora_react_1.ModalCloseButton, { onClick: onClose }), (0, jsx_runtime_1.jsx)(flora_react_1.ModalBody, { children: (0, jsx_runtime_1.jsx)(CustomerRecognitionForm_1.CustomerRecognitionForm, Object.assign({}, props)) })] })) })));
};
/**
 * @component
 * @name CustomerRecognitionFormModal
 * @description Formulário no formato de modal, para ser usado no fluxo de Reconhecimento de Cliente Final
 * para identificar o cliente.
 */
exports.CustomerRecognitionFormModal = react_1.default.memo(Component);
